import { RoomsCarousel } from "./RoomsCarousel";
import { RoomsFilters } from "./RoomsFilters";
import { RoomsList } from "./RoomsList";
import { RoomsMap } from "./RoomsMap";

type RoomsCompound = {
  Filters: typeof RoomsFilters;
  List: typeof RoomsList;
  Carousel: typeof RoomsCarousel;
  Map: typeof RoomsMap;
};

/** The rooms tab's parts. Each renders nothing on other tabs. */
export const Rooms: RoomsCompound = {
  Filters: RoomsFilters,
  List: RoomsList,
  Carousel: RoomsCarousel,
  Map: RoomsMap,
};
